import axios from 'axios';
import { createRequestHook } from '@clover-util/use-request';
import { getCeApiHostname } from 'util/Environment';

export const CE_HOSTNAME = getCeApiHostname();

const ceAxiosInstance = axios.create({
  baseURL: CE_HOSTNAME,
});

export const useCeRequest = createRequestHook(() => ceAxiosInstance);
